import {
  useAdminClubManagersQuery,
  useAdminDeleteClubManagerMutation,
  useAdminPostClubManagerMutation,
} from '@features/club/api/hooks';
import { Loader } from '@ui/components/Loader';
import { ClubAdminManagers } from '@features/club/ui/ClubAdminManagers';

type Props = {
  clubId: string;
};

export function ClubAdminManagersWidget({ clubId }: Props) {

  const { data: managers } = useAdminClubManagersQuery(clubId);
  const { mutateAsync: onPost, isPending: isPostPending } = useAdminPostClubManagerMutation(clubId);
  const { mutateAsync: onDelete, isPending: isDeletePending } = useAdminDeleteClubManagerMutation(clubId);

  const isPending = isPostPending || isDeletePending;

  if (!managers) return <Loader centered />;

  return (
    <ClubAdminManagers
      managers={managers}
      onAdd={onPost}
      onRemove={onDelete}
      disabled={isPending}
    />
  );
}
